import React, { useState } from 'react';

import { check } from '@/assets/icons';
import { Label } from '@/components/shared/Inputs/Label';
import {
	SettingsList,
	SettingsListItems,
} from '@/components/shared/SettingCard';
import { SingleActionLayout } from '@/components/shared/SingleActionLayout/SingleActionLayout';
import { SvgIcon } from '@material-ui/core';

import styles from './TagPicker.module.scss';

interface TagItem {
	label: string;
	capitalisedLabel: string;
}

interface TagPickerProps {
	label: string;
	songName?: string;
	items: TagItem[];
	selected: string[];
	multiSelect?: boolean;
	onSave: (tags: string[]) => void;
}

export const TagPicker: React.FC<TagPickerProps> = ({
	label,
	songName,
	items,
	selected: initialSelected,
	multiSelect = false,
	onSave,
}) => {
	const [selected, setSelected] = useState<string[]>(initialSelected);
	const [touched, setTouched] = useState(false);

	const settingsItems: SettingsListItems = items.map(
		({ label: key, capitalisedLabel }) => ({
			type: 'setting' as const,
			title: capitalisedLabel,
			trailingComponent: selected.includes(key) ? (
				<div className={styles['check--selected']}>
					<SvgIcon component={check} />
				</div>
			) : undefined,
			onClick: () => {
				setTouched(true);
				setSelected((prev) =>
					multiSelect
						? prev.includes(key)
							? prev.filter((s) => s !== key)
							: [...prev, key]
						: [key],
				);
			},
		}),
	);

	return (
		<SingleActionLayout
			noPadding
			actionDisabled={!touched}
			actionLabel="Save"
			onActionClick={() => onSave(selected)}
		>
			<div className={styles['root']}>
				<Label className={styles['label']}>
					{label}
					{songName && (
						<> <span className={styles['song-name']}>{songName}</span></>
					)}
				</Label>
			</div>
			<div className={styles['list-wrapper']}>
				<SettingsList items={settingsItems} />
			</div>
		</SingleActionLayout>
	);
};
